import type { CurrentRead } from '@signalvote/data';
import type { LastFiledCashDto } from '@signalvote/shared';
import { apiResponse } from './apiFetch';
import { financeReadKeys } from '../../lib/queryKeys';
import { campaignHeaders, defineQuery } from '../../lib/data';

export type { LastFiledCashDto };

const useLastFiledCashRead = defineQuery({
  key: financeReadKeys.dashboardLastFiledCash,
  reads: 'GET /api/finance/dashboard/last-filed-cash',
  fetch: async (_params: undefined, { signal, campaignId }) => {
    const response = await apiResponse('/api/finance/dashboard/last-filed-cash', {
      signal,
      headers: campaignHeaders(campaignId),
    });
    if (response.status === 404 || response.status === 204) return null;
    if (!response.ok) throw new Error('Failed to fetch last-filed cash on hand');
    return (await response.json()) as LastFiledCashDto | null;
  },
  staleTime: 30_000,
});

/**
 * The frozen last-filed cash-on-hand for the dashboard hero (ADR-017) — the only
 * cash-on-hand the dashboard shows, never a live cumulative balance. Ready with null
 * when no report has been filed ("No filing yet" is a valid, expected state, so a
 * 404 or null body is NOT an error).
 */
export function useLastFiledCash(): CurrentRead<LastFiledCashDto | null> {
  return useLastFiledCashRead(undefined);
}
